import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-creative';
window.Swiper = Swiper;
